import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShift"><Path d="M12.0012 1.5481L0.171875 14H6.00119V21H18.0012V14H23.8305L12.0012 1.5481Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShift;
